import type { Meeting } from "@repo/types";
import { ExportDialog } from "../common/ExportDialog";
import { ExportMeetingForm } from "./ExportMeetingForm";

export interface ExportMeetingDialogProps {
  getMeetings: () => Meeting[];
  getPreselectedFields: () => string[];
}

export const ExportMeetingDialog = ({
  getMeetings,
  getPreselectedFields,
}: ExportMeetingDialogProps) => {
  return (
    <ExportDialog
      title="Export Meetings"
      ExportForm={({ onCancel }) => (
        <ExportMeetingForm
          getMeetings={getMeetings}
          getPreselectedFields={getPreselectedFields}
          onCancel={onCancel}
        />
      )}
    />
  );
};
